import { render, staticRenderFns } from "./TireDialog.vue?vue&type=template&id=05b21d0a&"
import script from "./TireDialog.vue?vue&type=script&lang=js&"
export * from "./TireDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports